import { mapActions } from "vuex";

export default  {
	created () {    
	   this.updateDataPost({ 
		   data: { 
			   data: [],
			   route: 'save_proveedor', 
			   tablaPost: ['datos_monturas']
			}
		}) 
	},
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'monturaEditarFtn':
							await     
							this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_montura', 
									tablaPost: ['datos_proveedores_montura']
								 }
							 }) 
						break;
						case 'inactivarFtn' :							
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'inactive_montura', 
									tablaPost: ['datos_proveedores_montura']
								 }
							 }) 
						break;

					}
				}

				await this.save(event.save)
				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'monturaEditarFtn':
							if(this.indexData!==false)
							{
								await this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath]})	
							}
							else
							{
								let datos= {}
								datos.datos_proveedores_montura = await this.gettersDatalist('datos_proveedores_montura', this.dataForm[this.namePath].datos_proveedores_montura.name)[0]
								await this.pushDataGet({ data: datos})
							}		
						break;
						case 'inactivarFtn':
							await this.spliceDataGet(this.indexData)
						break;

					}
				}
				this.resetGlobal({state: 'indexData'})
				this.resetGlobal({state: 'openModal'})
				this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
